import * as React from "react";
import FieldComponent from "./FieldComponent";
import { Field, FieldAttributes, useFormikContext } from "formik";
import FormFieldLayout from "../FormFieldLayout";

interface Props {
  // whether this section is shown
  showPresentation?: boolean;
  showWithFormFieldLayout?: boolean;
  fieldProps: FieldAttributes<any>;
}

/**
 * The wrapper dealing with show or not and reset value if required
 * @param param0
 * @returns
 */
export const LifeSupportSection = ({
  showPresentation = false,
  showWithFormFieldLayout = false,
  fieldProps,
}: Props) => {
  const { setFieldValue } = useFormikContext();

  // Reset the field when it is not required
  React.useEffect(() => {
    if (!showPresentation) {
      setFieldValue(fieldProps.name, undefined);
    }
  }, [showPresentation, fieldProps.name, setFieldValue]);

  if (!showPresentation) return null;

  if (!showWithFormFieldLayout) {
    return <Field {...fieldProps} component={FieldComponent} />;
  }

  return (
    <FormFieldLayout multipleFields>
      <Field {...fieldProps} component={FieldComponent} />
    </FormFieldLayout>
  );
};
